"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.year = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _iconEqualHousing = _interopRequireDefault(require("@ux/balance-base/build/assets/images/icon-equal-housing.svg"));

var _iconFdic = _interopRequireDefault(require("@ux/balance-base/build/assets/images/icon-fdic.svg"));

var _isomorphicDompurify = _interopRequireDefault(require("isomorphic-dompurify"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["footerCopy", "footerIcons"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sanitizer = _isomorphicDompurify.default.sanitize;
var year = new Date().getFullYear();
exports.year = year;
var FooterLegal = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var footerCopy = _ref.footerCopy,
      footerIcons = _ref.footerIcons,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "footer__legal--global",
    ref: ref
  }, additionalProps), footerCopy.map(function (p) {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: p,
      className: "footer__copy",
      dangerouslySetInnerHTML: {
        __html: sanitizer(p)
      } // eslint-disable-line

    });
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer__icons"
  }, footerIcons.map(function (icon) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "footer__icon-link",
      href: icon.linkHref,
      key: icon.linkHref,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "footer__icon-graphic",
      src: icon.iconUrl,
      alt: icon.iconAltText
    }));
  })));
});
FooterLegal.displayName = 'FooterLegal';
FooterLegal.propTypes = {
  footerCopy: _propTypes.default.arrayOf(_propTypes.default.string),
  footerIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]))
};
FooterLegal.defaultProps = {
  footerCopy: ["&copy;".concat(year, " Regions Bank. All Rights Reserved."), 'Regions, the Regions logo and the LifeGreen bike are registered trademarks of Regions Bank. The LifeGreen color is a trademark of Regions Bank.'],
  footerIcons: [{
    iconUrl: _iconEqualHousing.default,
    linkHref: 'https://www.regions.com/help/equal-housing-lender',
    iconAltText: 'Equal Housing Lender logo'
  }, {
    iconUrl: _iconFdic.default,
    linkHref: 'https://www.regions.com/help/fdic-statement',
    iconAltText: 'FDIC logo'
  }]
};
var _default = FooterLegal;
exports.default = _default;